// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","container":"pl-layout_container__T3AYg","filterSectionTopSpacing":"pl-layout_filterSectionTopSpacing__qeqi9"};